"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {}
};

/**
 * Describe the purpose of ModalBody here
 */
var ModalBody = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ModalBody, _React$Component);
  function ModalBody(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ModalBody);
    _this = _callSuper(this, ModalBody, [props]);
    _this.disableSelectRenderInBody = _this.disableSelectRenderInBody.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  /**
   * Recursive finding Select component among children and update renderInBody to false for it
   * Fix for "Select dropdown goes outside of scrollable bounds"
   * https://www.mulesoft.org/jira/browse/UIFX-665
   */
  (0, _createClass2["default"])(ModalBody, [{
    key: "disableSelectRenderInBody",
    value: function disableSelectRenderInBody(children) {
      var _this2 = this;
      return _react["default"].Children.map(children, function (child) {
        var childProps = {};
        // Marker show necessity to modifying props
        var isSelectFound = false;
        if ( /*#__PURE__*/_react["default"].isValidElement(child) && child.type && child.type.displayName === 'Select') {
          isSelectFound = true;
          childProps = {
            renderInBody: false
          };
        }
        // Checking that child is not null and has props
        if (child && child.props) {
          // String has no Prop
          childProps.children = _this2.disableSelectRenderInBody(child.props.children);
        }
        if (isSelectFound) {
          return /*#__PURE__*/_react["default"].cloneElement(child, childProps);
        }
        return child;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        theme = _this$props.theme,
        testId = _this$props.testId,
        children = _this$props.children,
        _this$props$onRef = _this$props.onRef,
        onRef = _this$props$onRef === void 0 ? function () {} : _this$props$onRef;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(node) {
          return onRef(node);
        },
        className: (0, _classnames["default"])(className, theme.modalBody),
        "data-test-id": testId,
        "data-anypoint-component": ModalBody.displayName
      }, this.disableSelectRenderInBody(children));
    }
  }]);
  return ModalBody;
}(_react["default"].Component);
(0, _defineProperty2["default"])(ModalBody, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(ModalBody, "displayName", 'ModalBody');
//# sourceMappingURL=ModalBody.js.map